<template>
    <div>
        <header class="main-header">
            <!--  logo  -->
            <div class="logo-holder">
                <router-link to="/">
<!--                    <images src="../../assets/images/logo.png" alt="">-->
                </router-link>
            </div>
            <!-- logo end  -->
            <!-- nav-button-wrap-->
            <div class="nav-button-wrap color-bg nvminit" ref="btn_mobile_toggle" @click="toggleMobileMenu">
                <div class="nav-button">
                    <span></span><span></span><span></span>
                </div>
            </div>
            <!-- nav-button-wrap end-->
            <!-- header-search button  -->
            <!--            <div class="header-search-button">-->
            <!--                <i class="fal fa-search"></i>-->
            <!--                <span>Search...</span>-->
            <!--            </div>-->
            <!-- header-search button end  -->
            <!--  add new  btn -->
            <!--  add new  btn end -->
            <!--  header-opt_btn -->
            <div class="header-opt_btn tolt" data-microtip-position="bottom" data-tooltip="Language / Currency">
                <span><i class="fal fa-globe"></i></span>
            </div>
            <!--  header-opt_btn end -->
            <!--  cart-btn   -->
            <!--      <div class="cart-btn  tolt show-header-modal" data-microtip-position="bottom"-->
            <!--           data-tooltip="Your Wishlist / Compare">-->
            <!--        <i class="fal fa-bell"></i>-->
            <!--        <span class="cart-btn_counter color-bg">5</span>-->
            <!--      </div>-->
            <!--  cart-btn end -->
            <!--  login btn -->
            <div class="show-reg-form modal-open">
                <router-link to="/auth" v-if="!isLoggedIn">
                    <i class="fas fa-user"></i>
                    <span>Sign In</span>
                </router-link>
                <router-link to="/dashboard" v-else>
                    <i class="fas fa-user-circle"></i>
                    <span>
            My Account
          </span>
                </router-link>
            </div>
            <!--  login btn  end -->
            <!--  navigation -->
            <div class="main-menu nav-holder" ref="main_menu">
                <nav id="menu_desktop">
                    <ul class="no-list-style menu-panel-root" id="menu-panel-ra9v5">
                        <li>
                            <router-link to="/listings" class="nav">Listings <i class="fa fa-search"></i></router-link>
                        </li>
                    </ul>
                </nav>
                <nav class="menusb sliding-menu" id="menu_mobile">
                    <div class="sliding-menu-wrapper">
                        <ul class="no-list-style menu-panel-root" id="menu-panel-ra9v5" style="width: 300px;">
                            <li>
                                <router-link to="/" class="nav">Home <i class="fa fa-caret-down"></i></router-link>
                            </li>
                            <li>
                                <router-link to="/auth" :class="getActiveLink('auth')">Login <i
                                    class="fa fa-caret-down"></i>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    </div>

</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
    name: "HeaderComponent",
    data() {
        return {
            mobile_menu: false
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters['profile/loggedIn'];
        },
        ...mapGetters({
            'profile': 'profile/user'
        })
    },
    methods: {
        ...mapActions({
            'profile': 'profile/getProfile'
        }),
        getActiveLink(link) {
            return window.location.href.includes(link) || link === 'home' ? 'act-link' : 'nav'
        },
        toggleMobileMenu() {
            this.mobile_menu = !this.mobile_menu
            let menu = this.$refs.main_menu
            let width = window.innerWidth
            if (menu !== undefined) {
                if (width < 1071) {

                    // this.$refs.menu_hide_mobile.classList.add('d-none')
                    // this.$refs.menu_show_mobile.classList.remove('d-none')
                    // this.$refs.menu_show_mobile.classList.add('d-block')

                    if (this.$refs.main_menu.classList.contains('vismobmenu')) {
                        this.$refs.main_menu.classList.remove('vismobmenu')
                    } else {
                        this.$refs.main_menu.classList.add('vismobmenu')
                        this.$refs.main_menu.classList.remove('nav-holder')
                    }
                } else {

                    // this.$refs.menu_hide_mobile.classList.add('d-block')
                    // this.$refs.menu_hide_mobile.classList.remove('d-none')
                    // this.$refs.menu_show_mobile.classList.add('d-none')

                    if (!this.$refs.main_menu.classList.contains('vismobmenu')) {
                        this.$refs.main_menu.classList.add('nav-holder')
                        this.$refs.main_menu.classList.remove('vismobmenu')
                    } else {
                        this.$refs.main_menu.classList.remove('nav-holder')
                        this.$refs.main_menu.classList.add('vismobmenu')
                    }
                }
            }

        }
    },
    created() {
        this.toggleMobileMenu()
    }
}
</script>
